import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import VueSwal from 'vue-swal'
import store from './store'
import VueTheMask from 'vue-the-mask'
import helpers from './helpers'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import CachePlugin from "./plugins/cache-plugin";
import AuthService from './services/AuthService'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'animate.css/animate.css'
import './assets/css/main.css'

const audio = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/new-chat.mp3");
audio.loop = true;
const audio2 = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/new_msg.mp3");

Vue.use(VueResource);
Vue.use(VueSwal);
Vue.use(VueTheMask);
Vue.use(helpers);

Vue.use(CachePlugin, {
  prefix: "lebot_",
  autoload: false,
  mapVuex: null
});

let socketConnection = null;

if (localStorage.getItem('refresh_token')) {
  socketConnection = SocketIO(process.env.VUE_APP_BASE_SERVER, {
    auth: {
      token: localStorage.getItem('access_token')
    }
  });
  Vue.use(new VueSocketIO({
    debug: false,
    connection: socketConnection
  }));
}

const base_server = (localStorage.getItem('base_server') ? localStorage.getItem('base_server') : process.env.VUE_APP_BASE_SERVER);

Vue.mixin({
  data () {
    return {
      base_server,
      isAndroid: (typeof Android !== 'undefined'),
      isElectron: Boolean(!!window.electronAPI)
    }
  },

  methods: {
    playNotification() {
      if (audio.paused && this.$store.state.canPlay) {
        audio.play();
      }
    },

    pauseNotification() {
      if (!audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    },

    playNewMessage() {
      if (audio2.paused && this.$store.state.canPlay) {
        audio2.play();
      }
    },

    sendAndroidEvent(name, token) {
      if (this.isAndroid) {
        switch (name) {
          case 'removeEmpresaUser':
            Android.removeEmpresaUser();
            break;
          case 'setEmpresaUser':
            Android.setEmpresaUser(token);
            break;
          case 'toggleNotification':
            Android.toggleNotification(!!localStorage.getItem('notificationOn') ? 'on' : 'off');
            break;
          case 'playNotificacao':
            Android.playNotificacao();
            break;
          case 'silenciarNotification':
            Android.pauseNotification();
            break;
        }
      }
    },

    logout(login) {
      this.sendAndroidEvent('removeEmpresaUser');
      const refreshToken = localStorage.getItem('refresh_token');

      if (refreshToken) {
        this.$http.post('auth/logout', { refresh_token: refreshToken });
      }

      if (!this.isAndroid && window.OneSignal) {
        OneSignal.push(() => {
          OneSignal.removeExternalUserId();
          this.editarOnesignal(0);
        });
      }

      localStorage.clear();

      if (login) {
        if (this.$route.query.id) {
          sessionStorage.setItem('redirect', this.$route.fullPath);
        }

        window.location.href = "/login";
      }
    },

    editarOnesignal(push_habilitado) {
      this.$http.post('usuarios/onesignal', { push_habilitado }).then(res => {});
    }
  }
});

Vue.config.productionTip = false;
Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;
Vue.http.options.root = base_server;
AuthService.configure({
  socket: socketConnection,
  onAuthFailure: () => {
    localStorage.clear();

    if (router.currentRoute.name !== 'Login') {
      router.push('/login');
    }
  }
});
Vue.prototype.$auth = AuthService;

Date.prototype.toDateInputValue = (function() {
  let local = new Date(this);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0,10);
});

Vue.filter('phone', function (phone) {
  if (phone) {
    phone = phone.toString();
    phone = phone.length > 11 ? phone.substring(2, 13) : phone;

    if (phone.length === 10) {
      return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

    } else if (phone.length === 11) {
      return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
  }

  return phone
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
